import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { StyledTableHead } from "../../styles";
import NoDataMessage from "components/DataNotFound";
import { Skeleton } from "@mui/material";
import { DriverName } from "../../styles";

interface ComplaintsTableProps {
  data: any[];
  loading: boolean;
  searchParams: URLSearchParams;
  groupBy: string;
}

export const ComplaintsTable = ({ data, loading, searchParams, groupBy }: ComplaintsTableProps) => {
  const navigate = useNavigate();

  if (loading) {
    return <Skeleton variant="rectangular" width="100%" height={585} />;
  }

  if (data.length === 0) {
    return <NoDataMessage message="Nenhum dado de quebras disponível para o período selecionado" />;
  }

  return (
    <Table>
      <StyledTableHead>
        <TableRow>
          <TableCell>Posição</TableCell>
          <TableCell>Nome do {groupBy === "driver" ? "Motorista" : "Time"}</TableCell>
          <TableCell>Total de Pedidos</TableCell>
          <TableCell>Total de Quebras</TableCell>
          <TableCell>Quebras (%)</TableCell>
        </TableRow>
      </StyledTableHead>
      <TableBody>
        {data?.map((complaint, index) => (
          <TableRow key={index}>
            <TableCell>{complaint?.position || 0}</TableCell>
            <TableCell>
              <DriverName
                onClick={() => {
                  const newParams = new URLSearchParams(searchParams);
                  newParams.set("search", complaint.name);
                  navigate(`/driver-complaint?${newParams.toString()}`);
                }}
              >
                {complaint?.name || "N/A"}
              </DriverName>
            </TableCell>
            <TableCell>{complaint?.totalOrders || 0}</TableCell>
            <TableCell>{complaint?.totalComplaints || 0}</TableCell>
            <TableCell>{complaint?.complaintPercentage || 0}%</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
